import React from 'react';
import { Link } from 'react-router-dom';
import image from '../assets/img/Abt_ADF_Image_2.jpeg';
import image1 from '../assets/img/9.jpeg';
import logo from '../assets/img/adf.png';

const Focus = () => {
  return (
    <div className='w-full min-h-[70vh] lg:py-24 py-10 lg:mt-[-16px] mt-[580px] flex bg-blue-50 lg:px-10 px-5'>
      {/* Left side */}
      <div className='lg:w-[50%] md:w-[50%] w-full lg:ml-24 md:ml-12'>
        <div className='lg:w-[70%] md:w-[70%] w-[100%] lg:mt-[-40px]'>
          <h1 className='text-3xl font-semibold py-4'>About</h1>

          {/* Logo (Visible only on md & lg screens) */}
          <div className="hidden md:flex lg:flex justify-start">
            <img src={logo} alt="ADF Logo" className='w-[160px] h-[120px]' />
          </div>

          <img src={image} alt="Teaching" className='mt-8 w-[100%] h-[200px] rounded-lg md:hidden lg:hidden' />
          <p className='text-lg py-10 md:py-12 lg:pb-4 lg:pt-12'>
            African Development Foundation (ADF) is a non-profit organization founded in 1994 with a
            mission to promote education and social welfare in Nigeria.
          </p>
          <img src={image1} alt="Charity" className='mb-2 w-[100%] h-[200px] rounded-lg md:hidden lg:hidden' />        
          <p className='text-lg'>
            We believe in the importance of compassion, community, and collaboration to create a
            brighter future for all.
          </p>
        </div>

       {/* About Us Button */}
        <div className='mt-10'>
          <a
            href="https://drive.google.com/file/d/1nlaQs3MALFjGh-RVmi5u5oU2Vyoma3em/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className='bg-[#15381b] hover:bg-[#c6bab8] hover:text-[#15381b] text-white px-8 py-4 rounded-md transition duration-300 cursor-pointer'
          >
            View Brochure
          </a>
        </div>
      </div>

      {/* Right side */}
      <div className='w-[40%] mt-16 mr-2 hidden md:block lg:block'>
        <div className='w-full'>
          {/* Big image */}
          <img src={image} alt="Teaching" className='w-[90%] h-[450px]' />
        </div>
        <div className='mt-[-220px] ml-[-150px]'>
          {/* Small overlapping image */}
          <img src={image1} alt="Charity" className='w-[45%] h-[250px] rounded-[50%]' />
        </div>
      </div>
    </div>
  );
};

export default Focus;
